import React from 'react';
import { ContactDetails } from '../config/dataConfig';

const Contact = () => {
  return (
    <section id="contact" className="section">
      <div className="container">
        {/* Heading */}
        <div className="row mb-5 wow fadeInUp">
          <div className="col-lg-9 col-xl-8 mx-auto text-center">
            <h2 className="fw-600 mb-3">Let's Connect</h2>
            <hr className="heading-separator-line border-primary border-2 opacity-10 mx-auto" />
            <p className="text-4 text-muted">
              Whether you're looking for a brand identity, creative campaign, or
              digital design solution, I'd love to hear about your project.{' '}
            </p>
          </div>
        </div>
        {/* Heading End */}
        {/* Contact Form */}
        {/* <div className="row wow fadeInUp">
          <div className="col-lg-10 col-xl-9 mx-auto">
            <form id="contact-form"  ref={form} onSubmit={sendEmail}>
              <div className="row g-4">
                <div className="col-md-6">
                  <input
                    name="user_name"
                    type="text"
                    className="form-control border-2"
                    required
                    placeholder="Your Name"
                  />
                </div>
                <div className="col-md-6">
                  <input
                    name="user_email"
                    type="email"
                    className="form-control border-2"
                    required
                    placeholder="Your Email"
                  />
                </div>
                <div className="col-md-12">
                  <textarea
                    name="message"
                    className="form-control border-2"
                    rows={5}
                    required
                    placeholder="Tell us more about your needs........"
                    defaultValue={""}
                  />
                </div>
                <div className="col-md-12 text-center">
                  <button
                    id="submit-btn"
                    className="btn btn-primary rounded-pill d-inline-flex"
                    type="submit"
                  >
                    {sendingMail ? (
                      <>
                        <span
                          role="status"
                          aria-hidden="true"
                          className="spinner-border spinner-border-sm align-self-center me-2"
                        ></span>
                        Sending......
                      </>
                    ) : (
                      <>
                        Send Message
                       
                      </>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div> */}
        {/* Contact Form End */}
        <div className="brands-grid separator-border h-100 mt-5 wow fadeInUp">
          <div className="row justify-content-center">
            {ContactDetails.map(({ href, icon, p1, p2, title }, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-card-link text-decoration-none d-block h-100"
                >
                  <div className="featured-box text-center my-3 my-md-0 h-100">
                    <div className="featured-box-icon text-secondary text-opacity-50">
                      {' '}
                      <i className={icon} />
                    </div>
                    <h3 className="text-uppercase">{title}</h3>
                    <p className="text-muted mb-0">
                      {p1}
                      {p2 && (
                        <>
                          <br />
                          {p2}
                        </>
                      )}
                    </p>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
